export default "__VITE_ASSET__CVDFsQmA__"